import { render } from "./channelDetail.vue?vue&type=template&id=11298f16&scoped=true"
import script from "./channelDetail.vue?vue&type=script&lang=js"
export * from "./channelDetail.vue?vue&type=script&lang=js"

import "./channelDetail.vue?vue&type=style&index=0&id=11298f16&lang=scss"
import "./channelDetail.vue?vue&type=style&index=1&id=11298f16&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11298f16"],['__file',"src/views/data/components/channelDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11298f16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11298f16', __exports__)) {
    console.log('reload')
    api.reload('11298f16', __exports__)
  }
  
  module.hot.accept("./channelDetail.vue?vue&type=template&id=11298f16&scoped=true", () => {
    console.log('re-render')
    api.rerender('11298f16', render)
  })

}


export default __exports__